import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { addI18nTranslations } from "../../utils";

export default {
    title: "Components/Software Updates",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-software-updates",
    args: {
        privacyPolicyLink: "#privacy-policy",
        readMoreLink: "#read-more",
        tooltipLink: "#tooltip",
        url:
            "mock-data/machine-detail/software-updates-AllUpdatesSubscribed.json",
        urlFormPostApi:
            "mock-data/machine-detail/software-updates-form-submit.json",
        subscriptionStatus: "AllUpdatesSubscribed",
    },
    argTypes: {
        privacyPolicyLink: {
            control: "text",
        },
        readMoreLink: {
            control: "text",
        },
        tooltipLink: {
            control: "text",
        },
        url: {
            control: "text",
        },
        urlFormPostApi: {
            control: "text",
        },
        subscriptionStatus: {
            options: [
                "UpdatesNotAvailable",
                "UpdatesNotSubscribed",
                "UpdatesPartiallySubscribed",
                "AllUpdatesSubscribed",
                "WaitingForInstallationOfSecurityUpdate",
                "WaitingForInstallationOfFunctionalUpdate",
                "InstallationFailedOfSecurityUpdate",
                "InstallationFailedOfFunctionalUpdate",
                "UpdatesNotAvailableButSubscribed",
            ],
            control: { type: "radio" },
        },
    },
};

const namespace = "softwareUpdates";
const translations = {
    label: "Machine software",
    learnMore: "Learn more",
    subscribeButton: "Subscribe to updates",
    closeModalButton: "Close",
    subscriptionStatus: {
        UpdatesNotSubscribed: {
            label: "Updates not subscribed",
            tooltip: {
                copy:
                    "Information on machine software updates and the installation process:",
            },
        },
        UpdatesPartiallySubscribed: {
            label: "Updates partially subscribed",
            tooltip: {
                headline: "Subscribed software types",
            },
        },
        AllUpdatesSubscribed: {
            label: "Updates subscribed",
            tooltip: {
                headline: "Subscribed software types",
            },
        },
        WaitingForInstallationOfSecurityUpdate: {
            label: "Waiting for Installation",
            tooltip: {
                copy: "Waiting for Installation of security update",
            },
        },
        WaitingForInstallationOfFunctionalUpdate: {
            label: "Waiting for Installation",
            tooltip: {
                copy: "Waiting for installation of functional update",
            },
        },
        InstallationFailedOfSecurityUpdate: {
            label: "Installation has failed",
            tooltip: {
                copy: "Installation failed for security update",
            },
        },
        InstallationFailedOfFunctionalUpdate: {
            label: "Installation has failed",
            tooltip: {
                copy: "Installation failed for functional update",
            },
        },
    },
    updateTypes: {
        Security: {
            label: "Security",
            modalTooltip: {
                copy:
                    "The Installation must be started by the operator on the machine. The update duration is displayed there before installation",
            },
        },
        Functional: {
            label: "Functions & fixes",
            modalTooltip: {
                copy:
                    "The Installation must be started by the operator on the machine. The update duration is displayed there before installation.",
            },
        },
        Force: {
            label: "Automatic installation of quick updates",
            modalTooltip: {
                copy:
                    "The installation will be done automatically with the next reboot. The operator cannot prevent the update or determine the update time. There will be no backup created. The update duration is a few seconds to a maximum of a few minutes.",
            },
        },
    },
    modal: {
        headline: "Machine software updates",
        copy: {
            1: "Here you have the option to subscribe to software updates for your machine.",
            2: "If updates are available and subscribed to, they will be downloaded to your machine within the next few hours (parallel to main time) and will be ready for installation. You decide when to start the installation on the machine.",
        },
        machine: "Machine",
        formHeadline: "Select update type",
        changeSaved: "Your change was saved.",
        errorHeadline: "Something went wrong, please try again later.",
        form: {
            field: {
                privacyPolicy: {
                    label: "By activating the updates, you accept the",
                    linkLabel: "TRUMPF conditions for machine software updates",
                    validationError: "This field is required",
                },
                buttons: {
                    cancel: "Cancel",
                    submit: "Save",
                },
            },
        },
    },
};

addI18nTranslations({
    namespace,
    language: "de_DE",
    translations,
});

const Template = (args) => {
    return html` <ux-iws-software-updates-v2
        url="mock-data/machine-detail/software-updates-${args.subscriptionStatus}.json"
        url-form-post-api="mock-data/machine-detail/software-updates-form-submit.json"
        tooltip-link="${args.tooltipLink}"
        read-more-link="${args.readMoreLink}"
        privacy-policy-link="#privacy-policy"
        language="de-DE"
    >
    </ux-iws-software-updates-v2>`;
};

export const Default = Template.bind({});
Default.args = {
    subscriptionStatus: "AllUpdatesSubscribed",
};
Default.translations = translations;
Default.namespace = namespace;

export const updatesSubscribedButNotAvailable = Template.bind({});
updatesSubscribedButNotAvailable.args = {
    subscriptionStatus: "UpdatesNotAvailableButSubscribed",
};
